import React, { useContext, useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  Col,
  Container,
  Modal,
  Row,
  Table,
  OverlayTrigger,
  Popover,
  Spinner,
} from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import NotyfContext from "../../contexts/NotyfContext";
import {
  blankGetAllReportData,
  getAllReport,
} from "../../redux/slices/ReportSlice";
import moment from "moment";
import useWindowDimensions from "../../hooks/useWindowDimension";
import {
  ChevronDown,
  ChevronUp,
  ArrowRight,
  Check,
  ArrowDown,
  CheckCircle,
} from "react-feather";
import Score from "../../components/new/scores";
import "./ReportAuditNew.css";
import EditableTableRow from "./EditableTableRow";
import OnboardingSteps from "../../components/new/OnboardingSteps";
import InfoPopover from "../../components/new/InfoPopover";
import Joyride from "react-joyride";
import Hugs from "./hugs.png";

// Icons
import Icon1 from "../../assets/img/new/icons-1.svg";
import Icon2 from "../../assets/img/new/Icon-2-credit.svg";
import Icon3 from "../../assets/img/new/icons-3.svg";

import RobotWithCard from "./pdf-image/Holding Card.png"
import RobotWithEnvelope from "./pdf-image/Holding Envelope.png"
import RobotWithGlass from "./pdf-image/Magnifying glass.png"


import { confirmDisputeItems } from "../../redux/slices/DisputeCenterSlice";
import {
  callUserActvity,
  fetchCurrentReport,
  fetchNotification,
  setNotifcationBedge,
  setReportAuditSelection,
} from "../../redux/slices/CommonSlice";
import {
  blankDoNotDeleteDisputeStatus,
  reGenerateResult,
} from "../../redux/slices/ReportAuditSlice";
import {
  fetchTourProgresses,
  updateTourProgress,
} from "../../redux/slices/TourProgressSlice";
import $ from "jquery";
import { autoCompleteAppFlow } from "../../redux/slices/IdiqApiSlice";
import PDFReader from "../../components/PDFReader";
import { blankUploadDocument } from "../../redux/slices/UploadDocumentSlice";

const ReportAudit = ({ redirectDashboard }) => {
  const [run, setRun] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [userPDF, setUserPDF] = useState(null);
  const customJoyrideStyles = {
    options: {
      // Change the font size of the content in the tooltip
      textColor: "var(--bs-dark-blue)", // Change the text color (optional)
      zIndex: 1000, // Change the z-index (optional)
    },
    tooltip: {
      // Change the font size of the content in the tooltip
      fontSize: "18px",
      fontWeight: "500",
    },
  };

  const steps = [
    {
      target: ".first-step",
      content:
        "Here's your progress bar. This tells you where you are in the process.  Look at you... You're already on step 2!",
      disableBeacon: true,
    },
    {
      target: ".second-step",
      content: (
        <>
          <div>And look we're already on a first name basis!</div>
          <img
            src={Hugs}
            alt="Your image description"
            style={{ width: "50%" }}
          />
        </>
      ),
      options: {
        width: 50,
      },
    },
    {
      target: ".third-step",
      content:
        "Open Accounts refers to the total number of active credit accounts you currently have.",
    },
    {
      target: ".fourth-step",
      content:
        "Negative Accounts are credit accounts with late payments, defaults, or other negative marks on your credit report.",
    },
    {
      target: ".fifth-step",
      content:
        "Credit Utilization is the percentage of your available credit that you are currently using.",
    },
    {
      target: ".sixth-step",
      content:
        "Credit Inquiries are the number of times lenders have requested your credit report, which can impact your credit score.",
    },
    {
      target: ".seventh-step",
      content:
        "Credit History refers to the length of time you have had credit accounts open, which can affect your credit score.",
    },
    {
      target: ".eighth-step",
      content:
        "You can see your scores here. First you have your Current scores, which are where you are at ... currently.",
    },
    {
      target: ".ninth-step",
      content: (
        <>
          {" "}
          <p>
            And here we have your Potential Scores, which are where we are
            hoping to end up.
          </p>
          <p>
            Our lawyer said we're not allowed to guarantee you'll reach these
            scores, but let's just say if you follow the process, you're gonna
            be very happy.
          </p>
        </>
      ),
    },
    {
      target: ".tenth-step",
      content: (
        <>
          {" "}
          <p>
            The Negative Items table is where you can see all of your favorite
            movies. Just kidding I wanted to make sure you were paying
            attention.
          </p>
          <p>
            This is the table where you'll find all the negative accounts that
            you can dispute!
          </p>
          <p>
            If there is an account that you don't want to dispute for any
            reason, all you have to do is click the ✏️ icon
          </p>
          <p>
            ...then toggle any of the accounts you want to keep from being
            disputed....
          </p>
          <p>click 💾, and you're done!</p>
        </>
      ),
    },
    {
      target: ".eleventh-step",
      content: (
        <>
          {" "}
          <p>
            If there is an account that you don't want to dispute for any
            reason, all you have to do is click one of these pencils
          </p>
        </>
      ),
    },
    {
      target: ".twelfth-step",
      content: (
        <>
          {" "}
          <p>
            ...then toggle any of the accounts you want to keep from being
            disputed!{" "}
          </p>
        </>
      ),
    },
  ];

  // Tour Progresses
  const tourStatus = useSelector((state) => state.tourProgress.status);
  const tours = useSelector((state) => state.tourProgress.tours);

  useEffect(() => {
    if (tourStatus === "idle") dispatch(fetchTourProgresses());
  }, [tourStatus]);

  useEffect(() => {
    if (
      tours.filter(
        (tour) => tour.tour_name === "report-audit" && tour.completed
      ).length === 0
    )
      setRun(true);
    else if (["loading", "idle"].includes(tourStatus)) setRun(false);
    else setRun(false);
  }, [tours, tourStatus]);

  const handleJoyrideCallback = (data) => {
    const { type, status, index, action } = data;
    if (type === "tour:end")
      dispatch(updateTourProgress({ tour_name: "report-audit", completed: 1 }));
  };

  const navigate = useNavigate();
  const notyf = useContext(NotyfContext);
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const reportStatus = useSelector((state) => state.reports.getAllReportStatus);
  const getAllReportData = useSelector(
    (state) => state.reports.getAllReportData
  );
  const doNotDisputeStatue = useSelector(
    (state) => state.reportAudit.doNotDisputeStatue
  );
  const [showLoader, setShowLoader] = useState(false);
  const error = useSelector((state) => state.reports.error);
  let clientName = "";
  let tabledata = [];
  let scores = {
    equifax: 0,
    experian: 0,
    transunion: 0,
    equifax_label: "",
    transunion_label: "",
    experian_label: "",
    next_update_date: "",
    update_date: "",
  };
  let potienal_scores = {
    equifax: 0,
    experian: 0,
    transunion: 0,
    experian_change_ratio: "",
    equifax_change_ratio: "",
    transunion_change_ratio: "",
    equifax_label: "",
    experian_label: "",
    transunion_label: "",
    potential_update_date: "",
  };
  let isEqDash = 0;
  let isExDash = 0;
  let isTrDash = 0;
  let hints_tips = [];
  let creditSummary = {};
  let creditUtlization = [];
  useEffect(() => {
    dispatch(blankGetAllReportData());
  }, []);

  useEffect(() => {
    if (doNotDisputeStatue && Object.keys(doNotDisputeStatue).length > 0) {
      if (doNotDisputeStatue.error === 0) {
        dispatch(callUserActvity("Dispute item edited"));
        notyf.open({
          type: "success",
          message: "Dispute Item(s) Status Saved Successfully",
          duration: "3000",
          ripple: false,
          dismissible: false,
          position: {
            x: "right",
            y: "top",
          },
        });
        dispatch(blankDoNotDeleteDisputeStatus());
      }
    }
  }, [doNotDisputeStatue]);

  const handleCallApi = (isDashboard) => {
    if (document.querySelectorAll(".save-item").length > 0) {
      $.alert("Save Negative Item(s) to continue.");
      return;
    }

    setIsSubmitting(true);

    dispatch(confirmDisputeItems());
    dispatch(fetchNotification());
    dispatch(setNotifcationBedge(true));
    dispatch(reGenerateResult());
    if (isDashboard) {
      dispatch(
        callUserActvity(
          "Click on continue button on report-audit page to go to select plan"
        )
      );
      navigate("/enhance-disputes-round");
    } else {
      dispatch(callUserActvity("Click on continue button at report audit"));
      dispatch(setReportAuditSelection(3));
      navigate("/verify-info");
    }
  };

  const showFullCreditReport = async () => {
    dispatch(callUserActvity("Click on View Full Credit Report"));
    dispatch(setReportAuditSelection(1));
    const errorConfig = {
      type: "danger",
      message: "There was an error trying to fetch your full report",
      duration: 4000,
      ripple: false,
      dismissible: false,
      position: {
        x: "right",
        y: "top",
      },
    };
    setIsSubmitting(true);
    try {
      const automCompleted = await dispatch(autoCompleteAppFlow()).unwrap();
      if (automCompleted.error === 0) {
        const fullReport = await dispatch(fetchCurrentReport()).unwrap();
        // console.log(fullReport.error)
        if (fullReport.error === 0) {
          setUserPDF(`data:application/pdf;base64,${fullReport.data.pdf}`);
        } else {
          notyf.open(errorConfig);
        }
      } else {
        notyf.open(errorConfig);
      }
    } catch (error) {
      // console.log(error)
      notyf.open(errorConfig);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (reportStatus === "loading" || showLoader) {
    return <Loader />;
  } else if (reportStatus === "succeeded") {
    if (getAllReportData && Object.keys(getAllReportData).length > 0) {
      if (getAllReportData.error == 0) {
        let disputeData = getAllReportData.data.dispute_data;
        let deletedData = getAllReportData.data.deleted_accounts;
        clientName = getAllReportData?.data?.client_name;
        scores = getAllReportData?.data?.scores;
        potienal_scores = getAllReportData?.data?.potential_scores;
        creditUtlization = getAllReportData.data.credit_card_data;
        creditSummary = getAllReportData.data.credit_summary;
        let responseData = [];
        if (deletedData.length > 0) {
          responseData = deletedData.concat(disputeData);
        } else {
          responseData = disputeData;
        }
        responseData.length > 0 &&
          responseData.map((rdata, index) => {
            const data = { ...rdata };

            if (data.Equifax === "Not Reporting") {
              data.Equifax = "";
              isEqDash = 1;
            }
            if (data.Experian === "Not Reporting") {
              data.Experian = "";
              isExDash = 1;
            }
            if (data.Transunion === "Not Reporting") {
              data.Transunion = "";
              isTrDash = 1;
            }

            let subRows = [
              {
                header: "Account Type",
                data: [
                  !isEqDash ? data.type : "",
                  !isExDash ? data.type : "",
                  !isTrDash ? data.type : "",
                ],
              },
              {
                header: "Account Type - Detail:",
                data: [
                  !isEqDash ? data.payment_type : "",
                  !isExDash ? data.payment_type : "",
                  !isTrDash ? data.payment_type : "",
                ],
              },
              {
                header: "Account Status:",
                data: [
                  !isEqDash ? data.eq_status : "",
                  !isExDash ? data.ex_status : "",
                  !isTrDash ? data.tr_status : "",
                ],
              },
              {
                header: "Account Number:",
                data: [
                  !isEqDash ? data.eq_account_number : "",
                  !isExDash ? data.ex_account_number : "",
                  !isTrDash ? data.tr_account_number : "",
                ],
              },
              {
                header: "Date Opened:",
                data: [
                  !isEqDash ? moment(data.open_date).format("MM/DD/YYYY") : "",
                  !isExDash ? moment(data.open_date).format("MM/DD/YYYY") : "",
                  !isTrDash ? moment(data.open_date).format("MM/DD/YYYY") : "",
                ],
              },
              {
                header: "Balance",
                data: [
                  !isEqDash ? data.eq_balance : "",
                  !isExDash ? data.ex_balance : "",
                  !isTrDash ? data.tr_balance : "",
                ],
              },
              {
                header: "Credit Limit:",
                data: [
                  !isEqDash ? data.eq_limit : "",
                  !isExDash ? data.ex_limit : "",
                  !isTrDash ? data.tr_limit : "",
                ],
              },
              {
                header: "Last Reported:",
                data: [
                  !isEqDash
                    ? moment(data.reported_date).format("MM/DD/YYYY")
                    : "",
                  !isExDash
                    ? moment(data.reported_date).format("MM/DD/YYYY")
                    : "",
                  !isTrDash
                    ? moment(data.reported_date).format("MM/DD/YYYY")
                    : "",
                ],
              },
            ]; //Negative	Not Reporting
            let color = {
              Negative: "danger",
              "Not Reporting": "secondary",
              VERIFIED: "danger",
              "New Negative": "danger",
              DELETED: "success",
              REPAIRED: "success",
            };
            let obj = {
              account_name: (
                <div
                  className="text-medium-16"
                  dangerouslySetInnerHTML={{ __html: data.name }}
                ></div>
              ),
              account_type: (
                <div className="text-regular-16">
                  {data.type === "Open Account"
                    ? data.payment_type
                    : data.type === "INC IN BANKRUPTCY"
                    ? "Public Record"
                    : data.type}
                </div>
              ),
              account_status: (
                <div className="text-regular-16">
                  {data.payment_type === "INC IN BANKRUPTCY"
                    ? "Bankruptcy"
                    : data.payment_type}
                </div>
              ),
              equifax: data.Equifax && (
                <div className="d-flex flex-row ms-auto">
                  <div className="d-flex my-auto me-2">
                    {/* <Badge bg={`${color[data.Equifax]}`} className='rounded-circle' style={{ padding: '4px', display: 'block' }}></Badge> */}
                  </div>
                  {/* <div className='text-regular-16'>{data.Equifax}</div> */}
                </div>
              ),
              experian: data.Experian && (
                <div className="d-flex flex-row ms-auto">
                  <div className="d-flex my-auto me-2">
                    {/* <Badge bg={`${color[data.Experian]}`} className='rounded-circle' style={{ padding: '4px', display: 'block' }}></Badge> */}
                  </div>
                  {/* <div className='text-regular-16'>{data.Experian}</div> */}
                </div>
              ),
              transunion: data.Transunion && (
                <div className="d-flex flex-row ms-auto">
                  <div className="d-flex my-auto me-2">
                    {/* <Badge bg={`${color[data.Transunion]}`} className='rounded-circle' style={{ padding: '4px', display: 'block' }}></Badge> */}
                  </div>
                  {/* <div className='text-regular-16'>{data.Transunion}</div> */}
                </div>
              ),
              subRows: undefined,
              extraData: subRows,
              equifaxCheckbox: !isEqDash,
              experianCheckbox: !isExDash,
              transunionCheckbox: !isTrDash,
              id: data.id,
              edit_value: data.edit_value,
              eq_deleted: data.eq_deleted,
              ex_deleted: data.ex_deleted,
              tr_deleted: data.tr_deleted,
            };
            tabledata.push(obj);
          });
      }
    }
  } else if (reportStatus === "failed") {
    notyf.open({
      type: "danger",
      message: error,
      duration: "3000",
      ripple: false,
      dismissible: false,
      position: {
        x: "right",
        y: "top",
      },
    });
  }

  return (
    <React.Fragment>
      <Helmet title="Report Audit" />
      <style>
        {`

     
        .active .step-button {
              position: relative;
            }
            .active .step-button::after {
              content: '';
              position: absolute;
              top: -4px;
              left: -4px;
              transform: translate(-50%, -50%);
              width: 30px;
              height: 30px;
              border-radius: 50%;
              background-color: var(--bs-primary);
              animation: sonar 2s infinite;
              z-index: -1;
            }
            @keyframes sonar {
              0% {
                opacity: 1;
                transform: scale(0.5);
              }
              100% {
                opacity: 0;
                transform: scale(1.5);
              }
            }
            /* Change the button background color */
          .react-joyride__tooltip button {
            background-color: #0076FF !important; /* Change this to your desired color */
            border-color: #0076FF !important; /* Change this to your desired color */
          }

          /* Change the button hover background color */
          .react-joyride__tooltip button:hover {
            background-color: #1b1848 !important; /* Change this to your desired hover color */
            border-color: #0076FF !important; /* Change this to your desired hover color */
          }

          /* Change the button properties */
          .react-joyride__tooltip button[type="button"][data-action="back"] {
            appearance: none !important;
          background-color: transparent !important;
          border-style: none !important;
          color: #0076FF !important;
          cursor: pointer !important;
          font-family: "Anek Bangla", sans-serif !important;
          font-size: 16px !important;
          font-weight: 400 !important;
          line-height: 16px !important;
          margin: 0 !important;
          margin-right: auto !important;
          padding: 8px !important;
          text-align: center !important;
          text-transform: none !important;
          visibility: visible !important;


          }

          /* Change the button hover properties */
          button[type="button"][data-action="back"]:hover {
          color: var(--bs-dark-blue) !important; 
            background-color: none !important; 
            
          }

          div[style*="align-items: center; display: flex; justify-content: flex-end; margin-top: 15px;"] > div {
            /* Override the style here */
            flex: inherit !important;
          }

        `}
      </style>

      {userPDF ? (
        <Container className="p-0 report-audit">
          <div className="text-center">
            <div className="row">
              <div className="col-lg-12">
                <h3>Full Credit Report Powered by Disputely</h3>
              </div>
            </div>
            <div>
              <PDFReader
                url={userPDF}
                footer={
                  <div className="d-flex gap-2 justify-content-between flex-column flex-md-row align-items-center py-3">
                    <div style={{width: `${window.innerWidth > 765 ? 100 / 3 : 100}%`}}>
                      <div className="position-relative">
                        <Button
                          variant="secondary"
                          size="lg"
                          className="rounded-pill h-100 w-100 btn-sonar-effect"
                          onClick={() =>
                            navigate("/credit-builder", { replace: true })
                          }
                        >
                          View Credit Building Tools
                          <span className="fs-sm fw-sm d-block" style={{wordSpacing: 3}}>Can help you Boost your scores within just a couple weeks! </span>
                        </Button>
                        {/* <div class="sonar-effect bg-dark w-100 rounded-pill position-absolute" style={{zIndex: 0}}></div> */}
                      </div>
                      <div> <img src={RobotWithCard} className="img-fluid" style={{width: 150,}} alt="Robot With Card"/> </div>
                    </div>
                    <div style={{width: `${window.innerWidth > 765 ? 100 / 3 : 100}%`}}>
                      <div className='position-relative'>
                        <Button
                          variant="primary"
                          size="lg"
                          className="rounded-pill h-100 w-100 btn-sonar-effect"
                          style={{zIndex: 1}}
                          onClick={() => {
                            dispatch(setReportAuditSelection(2));
                            navigate("/credit-audit", { replace: true });
                          }}
                        >
                          View A.I Credit Audit
                          <span className="fs-sm fw-sm d-block" style={{wordSpacing: 3}}>Use A.I. to breakdown and analyze your current credit standing</span>
                        </Button>
                        {/* <div class="sonar-effect bg-secondary w-100 rounded-pill position-absolute" style={{zIndex: 0}}></div> */}
                      </div>
                      <div> <img src={RobotWithGlass} className="img-fluid" style={{width: 115,}} alt="Robot With Magnifying Glass"/> </div>
                    </div>
                    <div style={{width: `${window.innerWidth > 765 ? 100 / 3 : 100}%`}}>
                      <div className="position-relative">
                        <Button
                          variant="success"
                          size="lg"
                          style={{animationDuration: "1.1s"}}
                          className="rounded-pill h-100 w-100 btn-sonar-effect"
                          onClick={() =>
                            {
                              dispatch(blankUploadDocument());
                              navigate("/dispute-center", { replace: true })
                            }
                            
                          }
                        >
                          Generate Dispute Letters
                          <span className="fs-sm fw-sm d-block" style={{wordSpacing: 3}}>Remove Inaccurate or Derogatory Accounts to BOOST Scores Quickly!</span>
                        </Button>
                        {/* <div class="sonar-effect bg-info w-100 rounded-pill position-absolute" style={{zIndex: 0}}></div> */}
                      </div>
                      <div> <img src={RobotWithEnvelope} className="img-fluid" style={{width: 150,}} alt="Robot With Envelope"/> </div>
                    </div>
                  </div>
                }
              />
            </div>
          </div>
        </Container>
      ) : (
        <Container className="p-0 report-audit">
          {!redirectDashboard && (
            <>
              <Joyride
                showSkipButton={true}
                locale={{ last: "FINISH" }}
                styles={customJoyrideStyles}
                steps={steps}
                run={run}
                continuous={true}
                scrollToFirstStep={true}
                showProgress={false}
                hideCloseButton
                disableOverlayClose={true}
                disableCloseOnEsc={true}
                callback={handleJoyrideCallback}
              />
              <div className="first-step">
                <div className="row">
                  <div className="col-lg-12">
                    <h3>Disputes creating status</h3>
                  </div>
                </div>
                <OnboardingSteps
                  activeStepButtonLeft="-2px"
                  progressComplete="220px"
                  activeStep={2}
                />
              </div>
            </>
          )}

          <div style={{ gap: 16 }} className="d-flex flex-column mt-5">
            <h3 className="audit-heading">
              Great News{" "}
              <span className="second-step"> {clientName.split(" ")[0]}!</span>
            </h3>

            <p className="text-regular-16 mb-5">
              We successfully retrieved your latest credit reports and scores!
              <br />
              Let's take a quick look at your current credit standing!
            </p>
          </div>
          <div className="credit-box row">
            <Col
              lg={2}
              md={4}
              xs={8}
              className="mb-3 flex-lg-fill col-6 mx-auto"
            >
              <Card
                className="shadow d-flex flex-row rounded-4 border-2 justify-content-between px-4 py-4 mb-0 align-items-center third-step"
                style={{ borderColor: "#3D8AFF" }}
              >
                <div className="item-group">
                  <h2 className="text-dark-blue">
                    {creditSummary && Object.keys(creditSummary).length > 0
                      ? creditSummary.total_open_count
                      : 0}
                  </h2>
                  <div className="text-regular-16">Open Accounts</div>
                </div>
                <div className="status ">
                  <img className="icons-2" src={Icon1} alt="Icons" />
                </div>
              </Card>
            </Col>
            <Col
              lg={2}
              md={4}
              xs={8}
              className="mb-3 flex-lg-fill col-6 mx-auto"
            >
              <Card
                className="shadow d-flex flex-row rounded-4 border-2 justify-content-between px-4 py-4 mb-0 align-items-center fourth-step"
                style={{ borderColor: "#3D8AFF" }}
              >
                <div className="item-group">
                  <h2 className="text-dark-blue">
                    {creditSummary && Object.keys(creditSummary).length > 0
                      ? creditSummary.total_negative_count
                      : 0}
                  </h2>
                  <div className="text-regular-16">Negative Accounts</div>
                </div>
                <div className="status status-1">
                  <img className="icons-2" src={Icon2} alt="Icons" />
                </div>
              </Card>
            </Col>
            <Col
              lg={2}
              md={4}
              xs={8}
              className="mb-3 flex-lg-fill col-6 mx-auto fifth-step"
            >
              <Card
                className="shadow d-flex flex-row rounded-4 border-2 justify-content-between px-4 py-4 mb-0 align-items-center "
                style={{ borderColor: "#3D8AFF" }}
              >
                <div className="item-group">
                  <h2 className="text-dark-blue">
                    {creditSummary && Object.keys(creditSummary).length > 0
                      ? creditSummary.credit_utilization_percentage
                      : 0}
                    %
                  </h2>
                  <div className="text-regular-16">Credit Utilization</div>
                </div>
                <div className="status status-3">
                  <img className="vector-32" src={Icon2} alt="Vector 32" />
                </div>
              </Card>
            </Col>
            <Col
              lg={2}
              md={4}
              xs={8}
              className="mb-3 flex-lg-fill col-6 mx-auto sixth-step"
            >
              <Card
                className="shadow d-flex flex-row rounded-4 border-2 justify-content-between px-4 py-4 mb-0 align-items-center"
                style={{ borderColor: "#3D8AFF" }}
              >
                <div className="item-group">
                  <h2 className="text-dark-blue">
                    {creditSummary && Object.keys(creditSummary).length > 0
                      ? creditSummary.inquiries
                      : 0}
                  </h2>
                  <div className="text-regular-16">Credit Inquries</div>
                </div>
                <div className="status status-4">
                  <img className="icons-4" src={Icon3} alt="Icons" />
                </div>
              </Card>
            </Col>
            <Col
              lg={2}
              md={4}
              xs={8}
              className="mb-3 flex-lg-fill col-6 mx-auto"
            >
              <Card
                className="shadow d-flex flex-row rounded-4 border-2 justify-content-between px-4 py-4 mb-0 align-items-center seventh-step"
                style={{ borderColor: "#3D8AFF" }}
              >
                <div className="item-group">
                  <h2 className="text-dark-blue">
                    <span className="anekbangla-semi-bold-magic-potion-30px">
                      {creditSummary && Object.keys(creditSummary).length > 0
                        ? parseInt(moment().format("Y").toString()) -
                          parseInt(creditSummary.start_of_credit_history)
                        : 0}
                    </span>
                    <span></span>
                    <span style={{ fontSize: 18 }}> years</span>
                  </h2>
                  <div className="text-regular-16">Credit History</div>
                </div>
                <div className="status status-2">
                  <img className="icons-2" src={Icon1} alt="Icons" />
                </div>
              </Card>
            </Col>
          </div>

          {/* Replace Score UI */}
          <div className="row scores mt-5 pb-3">
            <div className="col-md-5 col-12 eighth-step">
              <h3>Current Scores</h3>
              <Score
                scores={{
                  transunion: {
                    value: scores.transunion,
                    label: scores.transunion_label,
                  },
                  experian: {
                    value: scores.experian,
                    label: scores.experian_label,
                  },
                  equifax: {
                    value: scores.equifax,
                    label: scores.equifax_label,
                  },
                }}
              />
            </div>
            <style>
              {`
            .potentialArrow .feather {
              width: 40px !important;
              height: unset !important;
            }
            `}
            </style>

            <div className="col-md-1 col-12 align-self-center pt-md-5 pb-md-0 py-5 potentialArrow">
              <div className="d-flex justify-content-center align-items-center mx-auto">
                {width <= 768 ? (
                  <ArrowDown className="feather" color="var(--bs-primary)" />
                ) : (
                  <ArrowRight
                    className="feather"
                    color="var(--bs-primary)"
                    size={40}
                  />
                )}
              </div>
            </div>

            <div className="col-md-6 col-12 ninth-step">
              <h3>
                Potential Scores{" "}
                <InfoPopover
                  headerContent="About Potential Scores"
                  bodyContent="The potential score is not a guarantee of what your scores will be, but rather a calculated estimate based on following our suggested steps to improve your scores. Our team will provide recommendations on how to increase your scores to reach your desired potential score."
                />
              </h3>

              <Score
                scores={{
                  transunion: {
                    value: potienal_scores.transunion,
                    percent: potienal_scores.transunion_change_ratio,
                    label: potienal_scores.transunion_label,
                  },
                  experian: {
                    value: potienal_scores.experian,
                    percent: potienal_scores.experian_change_ratio,
                    label: potienal_scores.experian_label,
                  },
                  equifax: {
                    value: potienal_scores.equifax,
                    percent: potienal_scores.equifax_change_ratio,
                    label: potienal_scores.equifax_label,
                  },
                }}
              />
            </div>
          </div>

          <div className="mt-5">
            <h3>Negative Items</h3>
            <p className="text-regular-16 mb-4">
              Confirm items in which to dispute. By default, all negative items
              are set to be disputed
              <InfoPopover
                headerContent="Disputing Negative Items"
                bodyContent="There might be a case where you would not wish to dispute an item. In this scenario, you don&#39;t have to! Simply click on the ✏️ icon, uncheck the account(s) you DO NOT wish to dispute, and then click 💾.  That&#39;s it!"
              />
            </p>
          </div>

          <Table
            responsive
            borderless
            className="w-100 table-auto white-space-nowrap negative-items mobile-overflow-x-auto tenth-step"
            style={{ tableLayout: "auto", whiteSpace: "nowrap" }}
          >
            <thead className="rounded-3" style={{ backgroundColor: "#F8F9FD" }}>
              <tr>
                <td>Account Name</td>
                <td>Account Type</td>
                <td>Account Status</td>
                <td>Experian</td>
                <td>Equifax</td>
                <td>Transunion</td>
                <td>Edit</td>
              </tr>
            </thead>
            <tbody>
              {tabledata.map((row, index) => (
                <EditableTableRow
                  key={index}
                  row={row}
                  index={index}
                  equifaxCheckbox={row.equifaxCheckbox}
                  experianCheckbox={row.experianCheckbox}
                  transunionCheckbox={row.transunionCheckbox}
                />
              ))}
            </tbody>
          </Table>

          <div className="d-flex align-items-center justify-content-end">
            <style>
              {`
            #reportAuditContinue {
              margin-right: 5rem !important
            }
            @media (max-width: 675.98px) {
#reportAuditContinue {
              margin-right: auto !important
             
            }
            }
            
            `}
            </style>

            {!redirectDashboard && (
              <Button
                id="reportAuditContinue"
                className="mt-5 px-5 d-flex text-center d-flex align-items-center"
                disabled={isSubmitting}
                onClick={() => showFullCreditReport()}
                variant="secondary"
                style={{ zIndex: "9999999999" }}
              >
                {isSubmitting && <Spinner animation="border" size="sm"  />}
                View Full Credit Report
              </Button>
            )}

            <Button
              id="reportAuditContinue"
              className="mt-5 px-5 d-flex text-center"
              disabled={isSubmitting}
              onClick={() => handleCallApi(redirectDashboard)}
              variant="primary"
              style={{ zIndex: "9999999999" }}
            >
              Dispute Negative Items
            </Button>
          </div>
        </Container>
      )}
    </React.Fragment>
  );
};

export default ReportAudit;
